<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ name: 'home' }">Inicio</el-breadcrumb-item>
          <el-breadcrumb-item>Solicitudes</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-card>
          <el-tabs>
            <el-tab-pane label="Solicitudes pendientes de revisión" class="solicitudes-pendientes-revision">
              <solicitudes-pendientes-lista></solicitudes-pendientes-lista>
            </el-tab-pane>
            <el-tab-pane label="Solicitudes revisadas" id="solicitudes-revisadas">
              <solicitudes-revisadas-lista></solicitudes-revisadas-lista>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {Breadcrumb, BreadcrumbItem, TabPane, Tabs} from "element-ui";
import SolicitudesPendientesLista
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesPendientes/SolicitudesPendientesLista/SolicitudesPendientesLista";
import SolicitudesRevisadasLista
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudesRevisadasLista/SolicitudesRevisadasLista";

export default {
  components: {
    SolicitudesPendientesLista,
    SolicitudesRevisadasLista,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
}
</script>
